var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VehicleRentalIndex',{attrs:{"fst-id":_vm.fstId,"pageTitle":_vm.title,"qso":_vm.qso,"endpoint":_vm.endpoint,"filterItems":_vm.filterOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }